import { render, staticRenderFns } from "./ProductDetailCategoryView.vue?vue&type=template&id=09a6f04a&scoped=true"
import script from "./ProductDetailCategoryView.vue?vue&type=script&lang=js"
export * from "./ProductDetailCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6f04a",
  null
  
)

export default component.exports